import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const CABECERA = 'Subscription-Key';

/**
 * Adjunta la clave de suscripcion de APIM a las llamadas salientes.
 *
 * Antes la ponia `CallHttpService` en cada metodo, lo que obligaba a recordarlo
 * en cada servicio nuevo. Aqui se resuelve una vez.
 *
 * Si la peticion ya trae la cabecera, se respeta y no se toca: es lo que hace
 * `PaymentService`, que fija la clave del middleware de pagos por su cuenta. Su
 * contrato quedo verificado contra transacciones reales y no se altera desde
 * aqui (Regla 8 de .ralph/PROMPT.md).
 */
export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(CABECERA)) {
    return next(req);
  }

  // Solo se firman las APIs propias: un tercero como reCAPTCHA no lleva clave.
  if (!esApiPropia(req.url)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { [CABECERA]: environment.apiManagementConfig.academyApi },
    }),
  );
};

function esApiPropia(url: string): boolean {
  return [
    environment.apiSolicitud,
    environment.apiDocument,
    environment.apiRegistration,
    environment.apiAdministration,
    environment.apiGestion,
  ].some((base) => !!base && url.startsWith(base));
}
